import { render, staticRenderFns } from "./post-online-training.vue?vue&type=template&id=efd42f88&scoped=true&"
import script from "./post-online-training.ts?vue&type=script&lang=ts&"
export * from "./post-online-training.ts?vue&type=script&lang=ts&"
import style0 from "./post-online-training.scss?vue&type=style&index=0&id=efd42f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd42f88",
  null
  
)

export default component.exports